var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 99.5,
    fill: "url(#paint0_linear_7502_51286)",
    stroke: "#211614"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.544 80.5368L148.434 57.8122C121.609 36.5266 80.6364 37.8603 57.0492 64.4295C49.232 73.2351 44.2061 84.7227 43.6259 98.6576C42.8187 118.045 51.5272 136 65.1029 145.638C90.7819 163.867 125.354 159.468 149.997 142.187L134.899 118.121C116.778 132.215 83.5069 130.872 81.2077 102.684C78.9084 74.4967 110.067 66.4429 131.544 80.5368Z",
    fill: "#f5f5f5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7502_51286",
    x1: 140,
    y1: 174,
    x2: 40,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#211614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211614"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaraLogo);
export default __webpack_public_path__ + "static/media/cara-logo.36c281b5a1195060a94006eedd0c34eb.svg";
export { ForwardRef as ReactComponent };